import axios from 'axios';
import { logApiError } from '@/utils/debugLogger';

// Get backend URL from environment variable or derive from current host
const getBackendURL = () => {
  // If REACT_APP_BACKEND_URL is set, use it
  if (process.env.REACT_APP_BACKEND_URL) {
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
  }
  const hostname = window.location.hostname;
  // Cloudflare Tunnel: frontend=karporat.dalartservice.com → backend=api-karporat.dalartservice.com
  if (hostname === 'karporat.dalartservice.com') {
    return 'https://api-karporat.dalartservice.com/api';
  }
  // Russia VPS proxy: use same-origin /api/ (nginx proxies to backend)
  if (hostname === 'ru-karporat.dalartservice.com') {
    return '/api';
  }
  // Local dev: use current hostname with backend port 8001
  return `http://${hostname}:8001/api`;
};

const API_BASE = getBackendURL();

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    // Токен может быть в localStorage (запомнить) или sessionStorage (сессия)
    const storage = localStorage.getItem('remember_me') === '1' ? localStorage : sessionStorage;
    const token = storage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling and debug logging
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config || {};
    const method = (config.method || 'GET').toUpperCase();
    const url = config.url || 'unknown';
    const status = error.response?.status || 0;
    const detail = error.response?.data?.detail || error.message || 'Network Error';

    // Логируем в Debug Panel (кроме 401 — это ожидаемое поведение)
    if (status !== 401) {
      logApiError(method, url, status, detail);
    }

    // 401 - редирект на login (очищаем оба хранилища)
    if (status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      localStorage.removeItem('remember_me');
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('user');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default apiClient;
